import React, { Component } from "react";
import { Row, Col, Progress, Table, Modal } from "antd";
import store from "../../reducers/";
import I18n, { fromSyntax } from "../../i18n";
import { OButton } from "../button/";
import { Circle } from "rc-progress";
import ActivityLog from "../home/ActivityLog";
import WelcomeText from "../text/WelcomeText";
import { isAlive } from "../../util";
import NumberUtil from "../../util/number";
import moment from "moment";
import ProgressBar from "../bar/ProgressBar";
import styled from "styled-components";
import { Metrics } from "../../theme";

const dataSource = [
	{
		key: "1",
		activity: "Add new User",
		date: "14/01/2018",
		by: "Admin"
	},
	{
		key: "2",
		activity: "Add new User",
		date: "14/01/2018",
		by: "Admin"
	},
	{
		key: "3",
		activity: "Add new User",
		date: "14/01/2018",
		by: "Admin"
	},
	{
		key: "4",
		activity: "Add new User",
		date: "14/01/2018",
		by: "Admin"
	}
];

const UserCapVal = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 36px;
	color: #4a4a4a;

	.maxValue {
		color: #d8d8d8;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 200px;
	}
`;

class AccountInformation extends Component {
	constructor(props) {
		super(props);

		this.text = {
			account_analytic_headcount: I18n.t("account_analytic_headcount"),
			account_registered_user: I18n.t("account_registered_user"),
			package_format: I18n.t("package_format"),
			buy_package: I18n.t("buy_package"),
			contact_buy_package: I18n.t("contact_buy_package"),
			expired: I18n.t("expired"),
			expire_date: I18n.t("expire_date"),
			expiration_date: I18n.t("expiration_date"),
			remaining_sessions: I18n.t("remaining_sessions"),
			sale_email: I18n.t("sale_email")
		};
	}

	renderProgressCircle = () => {
		const {
			max_wallet_time = 0,
			wallet_time = 0
		} = store.getState().organization.organization;
		const max_wallet = max_wallet_time ? parseInt(max_wallet_time).format() : 0;
		const wallet = wallet_time ? parseInt(wallet_time).format() : 0;
		return (
			<Progress
				type="circle"
				percent={(parseInt(wallet_time) / parseInt(max_wallet_time)) * 100}
				width={230}
				format={percent => (
					<div>
						<div>
							<div
								style={{ fontSize: 36, color: "#4a4a4a", fontWeight: "bold" }}
							>{`${wallet}`}</div>
							<div
								style={{ fontSize: 24, color: "#d8d8d8", marginTop: 3 }}
							>{`/${max_wallet}`}</div>
						</div>
						<div style={{ fontSize: 16, color: "#d8d8d8", marginTop: 10 }}>
							{this.text.remaining_sessions}
						</div>
					</div>
				)}
			/>
		);
	};

	render() {
		const {
			organization: { organization }
		} = store.getState();
		const { color, name, expire, user_cap = 0 } = organization;
		const expireDate = moment.unix(expire).format("DD/MM/YYYY");
		const expireIn = moment.unix(expire).diff(moment(), "days");
		const { logs, active_employees, registered_user } = this.props;
		return (
			<div>
				<WelcomeText />
				<Row gutter={16}>
					<Col xs={24} sm={24} md={24} lg={12} xl={12}>
						<Row style={{ marginBottom: "12px" }}>
							<Col xs={0} sm={0} md={0} lg={12} style={{ textAlign: "right" }}>
								{this.renderProgressCircle()}
							</Col>
							<Col
								md={24}
								lg={0}
								style={{ textAlign: "center", marginBottom: 30 }}
							>
								{this.renderProgressCircle()}
							</Col>
							<Col
								xs={24}
								sm={24}
								md={24}
								lg={12}
								xl={12}
								style={{ textAlign: "center", marginBottom: 30 }}
							>
								{organization.package ? (
									<div style={{ color, fontSize: 36 }}>
										{fromSyntax(this.text.package_format, {
											name: organization.package
										})}
									</div>
								) : null}

								<div style={{ marginBottom: 20 }}>
									<div style={{ fontSize: 36, color: "#4a4a4a" }}>
										{expireDate}
									</div>
									<div
										style={{ fontSize: 14, color: "#d8d8d8", lineHeight: 0 }}
									>
										{this.text.expiration_date}
									</div>
								</div>
								<div
									style={{
										color: expireIn >= 0 ? color : "red",
										fontSize: 12,
										marginBottom: 10
									}}
								>
									{expireIn >= 0
										? fromSyntax(this.text.expire_date, { expireIn })
										: this.text.expired}
								</div>
								<OButton
									onClick={() =>
										Modal.info({
											title: this.text.buy_package,
											content: (
												<div>
													<span>{this.text.contact_buy_package} </span>
													<a
														href={`mailto:${this.text.sale_email}`}
														style={{ color }}
													>
														{this.text.sale_email}
													</a>
												</div>
											),
											onOk() {}
										})
									}
								>
									{this.text.buy_package}
								</OButton>
							</Col>
						</Row >
						<Row>
							<Col xs={24} lg={20}>
								<span>
									<p style={{ color: "#f5222d" }}>
										*Remaining session = your current remaining sessions that
										can be used every 30 minutes video call will be counted as 1
										session e.g. 60 minutes continuous video call will be
										counted as 2 sessions
									</p>
								</span>
							</Col>
						</Row>
					</Col>
					<Col xs={24} sm={24} md={24} lg={11} xl={11}>
						<ActivityLog dataSource={logs} />
					</Col>
				</Row>
				<Row
					gutter={6}
					type="flex"
					justify="space-around"
					align="middle"
					style={{
						textAlign: "center",
						padding: `${Metrics.button.bigSpaceMargin / 2}px 0px`
					}}
				>
					<Col
						span={4}
						style={{ textAlign: "center", fontSize: 18, color: "#4a4a4a" }}
					>
						{this.text.account_analytic_headcount}
					</Col>
					<Col span={15} style={{ textAlign: "center" }}>
						<ProgressBar percent={(active_employees / user_cap) * 100} />
					</Col>
					<Col span={5}>
						<UserCapVal style={{ display: "inline-flex" }}>
							<p>{`${active_employees}` + (isAlive(user_cap) ? "/" : "")}</p>
							<p className="maxValue" title={user_cap}>
								{user_cap}
							</p>
						</UserCapVal>
					</Col>
				</Row>
				<Row
					gutter={6}
					type="flex"
					justify="space-around"
					align="middle"
					style={{
						textAlign: "center",
						padding: `${Metrics.button.bigSpaceMargin / 2}px 0px`
					}}
				>
					<Col
						span={4}
						style={{ textAlign: "center", fontSize: 18, color: "#4a4a4a" }}
					>
						{this.text.account_registered_user}
					</Col>
					<Col span={15} style={{ textAlign: "center" }}>
						<ProgressBar percent={(registered_user / user_cap) * 100} />
					</Col>
					<Col span={5}>
						<UserCapVal style={{ display: "inline-flex" }}>
							<p>{`${registered_user}` + (isAlive(user_cap) ? "/" : "")}</p>
							<p className="maxValue" title={user_cap}>
								{user_cap}
							</p>
						</UserCapVal>
					</Col>
				</Row>
			</div>
		);
	}
}

export default AccountInformation;



// WEBPACK FOOTER //
// ./src/components/account/AccountInformation.js